import { AppLink } from "@/shared/components/AppLink";
import { Container } from "@/shared/components/Container";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Footer.module.css";

const SOCIALS = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/autou/posts/?feedView=all",
    icon: "/assets/linkedin.svg",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/autou.io/",
    icon: "/assets/instagram.svg",
  },
  {
    label: "WhatsApp",
    href: "https://api.whatsapp.com/send/?phone=5511987096060&text&type=phone_number&app_absent=0",
    icon: "/assets/whatsapp.svg",
  },
];

const OFFICES = [
  { label: "São Paulo", href: "https://maps.app.goo.gl/J7whCVStHfp5GBmu6" },
  { label: "Rio de Janeiro", href: "https://maps.app.goo.gl/v9nVEagJQeg3FQW87" },
];

export function Footer() {
  const locale = useLocale();
  const content = getHomeContent(locale);
  const prefix = locale === "en" ? "/en" : "";

  const siteLinks = [
    { label: content.nav.results, href: `${prefix}/#resultados` },
    { label: content.nav.cases, href: `${prefix}/#cases` },
    { label: content.nav.method, href: `${prefix}/#metodo` },
    { label: content.nav.education, href: `${prefix}/#educacao` },
    { label: content.nav.articles, href: `${prefix}/#artigos` },
  ];

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.top}>
          <div className={styles.brand}>
            <div className={styles.brandMarks}>
              <img
                className={styles.logo}
                src="/assets/logo-autou-orange.svg"
                alt="AutoU"
                width={160}
                height={41}
                loading="lazy"
                decoding="async"
              />
              <span className={styles.brandSeparator} aria-hidden />
              <img
                className={styles.seal}
                src="/assets/selo-dourado.webp"
                alt="Cubo Itaú Startup 2025"
                width={56}
                height={56}
                loading="lazy"
                decoding="async"
              />
            </div>
            <p className={styles.tagline}>{content.footer.tagline}</p>
            <div className={styles.socials}>
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  className={styles.social}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                >
                  <img
                    src={social.icon}
                    alt=""
                    aria-hidden
                    width={20}
                    height={20}
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h2 className={styles.colTitle}>{content.footer.siteHeading}</h2>
            <ul className={styles.colList}>
              {siteLinks.map((item) => (
                <li key={item.href}>
                  <AppLink className={styles.colLink} href={item.href}>
                    {item.label}
                  </AppLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className={styles.colTitle}>{content.footer.officesHeading}</h2>
            <ul className={styles.colList}>
              {OFFICES.map((office) => (
                <li key={office.href}>
                  <a
                    className={styles.colLink}
                    href={office.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={content.footer.openMapsAria(office.label)}
                  >
                    {office.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <hr className={styles.divider} />
        <div className={styles.bottom}>
          <p className={styles.copyright}>{content.footer.copyright}</p>
          <a
            className={styles.privacy}
            href={locale === "en" ? "/en/privacy" : "/privacidade/declaracao-de-privacidade.pdf"}
            target="_blank"
            rel="noopener noreferrer"
          >
            {content.footer.privacyPolicy}
          </a>
          <button
            className={styles.privacy}
            type="button"
            onClick={() => window.dispatchEvent(new Event("autouprivacyopen"))}
          >
            {content.footer.privacyPreferences}
          </button>
        </div>
      </Container>
    </footer>
  );
}
